import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { map, size } from 'lodash/fp';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button, ButtonToolbar, Icon, Loader, Timeline } from 'rsuite';
import {
  deleteGuestNote,
  fetchGuestNotes
} from '../../../redux/sagas/routines';
import {
  getMeta,
  getFetching,
  getDeleting
} from '../../../redux/Guest/selectors/note';
import { NoteType } from '../../../interfaces';
import NoteItem from './NoteItem';
import DeleteConfirmationModal from '../../DeleteConfirmationModal';

const TimelineItem = styled(Timeline.Item)`
  padding-left: 30px !important;
  > .rs-timeline-item-content {
    margin-bottom: 15px;
    padding-bottom: 10px !important;
    border-bottom: 1px dashed #efefef;
  }
  > .rs-timeline-item-dot {
    top: 0px;
    position: absolute;
    left: -8px !important;
    background: #fff;
    width: 26px;
    height: 22px;
  }
`;

const NotesList = ({ guestId, data, onEdit }) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getFetching);
  const { page = 1, total = 0 } = useSelector(getMeta);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [noteIdToDelete, setNoteIdToDelete] = useState(null);
  const isDeleting = useSelector(getDeleting);
  const dataCount = size(data);
  const handleShowMore = () => {
    dispatch(fetchGuestNotes({ guestId, page: page + 1 }));
  };

  const handleShowDeleteModal = noteId => {
    setNoteIdToDelete(noteId);
    setShowDeleteModal(true);
  };

  const handleHideDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    setShowDeleteModal(false);
    dispatch(deleteGuestNote(noteIdToDelete));
  };

  return (
    <Fragment>
      <Timeline align="left">
        {map(note => {
          const { id } = note;
          return (
            <TimelineItem key={`note-${id}`} dot={<Icon icon="comment" />}>
              <NoteItem
                key={`item-${id}`}
                data={note}
                onEdit={onEdit}
                onDelete={handleShowDeleteModal}
              />
            </TimelineItem>
          );
        }, data)}
      </Timeline>
      {isFetching && <Loader content="Loading..." style={{ marginTop: 10 }} />}
      {dataCount < total && (
        <ButtonToolbar style={{ marginTop: 20 }}>
          <Button
            appearance="primary"
            disabled={isFetching}
            onClick={handleShowMore}
          >
            Show More...
          </Button>
        </ButtonToolbar>
      )}

      {noteIdToDelete && (
        <DeleteConfirmationModal
          message="Are you sure you want to delete this note?"
          show={showDeleteModal}
          onHide={handleHideDeleteModal}
          onConfirm={handleConfirmDelete}
          isDeleting={isDeleting}
        />
      )}
    </Fragment>
  );
};

NotesList.propTypes = {
  guestId: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(NoteType).isRequired,
  onEdit: PropTypes.func.isRequired
};

NotesList.defaultProps = {};

export default NotesList;
